export const GET_LIST = '/machines/get_list';
export const SHOW_DATA = '/machines/show_data';
export const CREATE_DATA = '/machines/create_data';
export const UPDATE_DATA = '/machines/update_data';
export const REMOVE_DATA = '/machines/remove_data';

export const FORM_DATA = {
  name: '',
  description: '',
  brand_model: '',
  capacity: '',
};
